import React, { Component } from "react";
import Grid from "@material-ui/core/Grid";
import { ProjectData } from "../components/ProjectData";
import { ProjectKeyInformation } from "../components/ProjectKeyInformation";
import { EntityInCharge } from "../components/EntityInCharge";
import { ProjectFinancialData } from "../components/ProjectFinancialData";
import { ProjectDates } from "../components/ProjectDates";
import { RomReview } from "../components/RomReview";
import Button from "@material-ui/core/Button";
import { inject, observer } from "mobx-react";
import { stores } from "../store";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ProjectSelect } from "../components/ProjectSelect";
import { RomData } from "../components/RomData";

import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import TextField from '@material-ui/core/TextField';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Autocomplete from '@material-ui/lab/Autocomplete';
import MUIDataTable from "mui-datatables";

import CircularProgress from '@material-ui/core/CircularProgress';

import 'moment-timezone';
import moment from 'moment'

//import API from '../api'
const CreateMissionPage = inject("userStore")(observer(class CreateMissionPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            typeOfROM: "",
            //projectTitle: "",
            //projectNumber: "",
            //status: "",
            //sector: "",
            //smcsCode: "",
            //cfcuContractManager: "",
            //deuaSectorExpert: "",
            //deuaMonitoringExpert: "",
            //eudSectorManager: "",
            //beneficiaryInstitution: "",
            //contractingPartner: "",
            //totalBudget: "",
            //euContribution: "",
            //nationalCoFinancing: "",
            //otherCoFinancing: "",
            //totalFundsDisbursed: "",
            //lastDateOfPayment: new Date(),
            //contractorSignatureDate: new Date(),
            //projectStartDate: new Date(),
            //finalDate: new Date(),
            reasonfortheRomReview: "",
            //romExpertName: "",
            //coMonitor: "",
            fieldPhaseStartDate: new Date(),
            fieldPhaseEndDate: new Date(),

            missionMonitor: null,
            missionQualityController: null,
            missionQualityAssurance: null,
            stakeholderName: "",
            stakeholderSurname: "",
            stakeholderCompany: "",
            stakeholderEmail: "",
            //stakeholders: [{
            //    stakeholderRowKey: 0,
            //    stakeholderName: "",
            //    stakeholderSurname: "",
            //    stakeholderCompany: "",
            //    stakeholderEmail: ""
            //}],
            stakeholders: new Array(),
            projects: [],
            missions: [],
            users: [],
            monuserid: 0,
            qcuserid: 0,
            qauserid: 0,

            loading: true,
            notAuthorized: true,

            stakeholderRowKey: 0,
            //test: [],

            isFetching: false,
            userType: -1,
        };
    }

    async componentDidMount() {

        let pageTokenAuthData = {
            operation: "AuthCheckToken"
        };

        await fetch(global.variables.API_CHECKTOKEN, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(pageTokenAuthData)
        })
            .then(response => response.json())
            .then(result => {
                if (result.resultstate > 0 ||
                    result.authresp === 2) {
                    window.location.href = "/login";
                }
            }).catch(() => {
                window.location.href = "/login";
            });

        await this.getUserType();

        await this.loadPage();

        if (!this.state.notAuthorized) {
            await this.loadPageProjects();
            await this.loadPageUsers();
        }
    }

    handleChange = async (e) => {
        //console.log(e);
        e.persist();
        await this.setState({ [e.target.name]: e.target.value });
    };

    handleChangeDate = (name, value) => {
        console.log(name);
        console.log(value);

        //this.setState({ [name]: new Date(value) });
        this.setState({ [name]: new Date(moment(value).format('YYYY-MM-DD')) });
    };

    handleProjectSelectChange = async (e, v) => {
        e.persist();

        //console.log(e.target.idProjectDetails);

        if (v !== undefined & v !== null) {
            //if (v !== null) {
            await this.setState({ selectedprojectid: v.idProjectDetails });
            //    //console.log(" :: " + e.target.name + " " + e.target.value + " " + v.idProjectDetails + " " + e.target.textContent);

            //    //for (var propertyKey in v) {
            //    //    console.log(v + " " + propertyKey + " " + v[propertyKey]);
            //    //}

            //await this.loadPageBeneficiaries();
            //await this.loadPageMONQC();
        } else {
            await this.setState({
                selectedprojectid: -1,
                stakeholders: [],
                missionMonitor: null,
                missionQualityController: null,
                missionQualityAssurance: null
            });
        }
    }

    handleSelectChange = async (e, v, vname) => {
        e.persist();

        if (v !== undefined & v !== null) {
            await this.setState({ [vname]: v.TypeId });
        } else {
            await this.setState({ [vname]: -1 });
        }

        //console.log(vname + ": " + e.target.value);
        console.log(this.state);
    }

    handleMONUserChange = (e, v) => {
        e.persist();
        if (v !== undefined & v !== null) {
            this.setState({
                monuserid: v.idLoginCredentials,
                missionMonitor: v
            });
        } else {
            this.setState({
                monuserid: -1,
                missionMonitor: null
            });
        }
    }

    handleQCUserChange = (e, v) => {
        e.persist();
        if (v !== undefined & v !== null) {
            this.setState({
                qcuserid: v.idLoginCredentials,
                missionQualityController: v
            });
        } else {
            this.setState({
                qcuserid: -1,
                missionQualityController: null
            });
        }
    }

    handleQAUserChange = (e, v) => {
        e.persist();
        if (v !== undefined & v !== null) {
            this.setState({
                qauserid: v.idLoginCredentials,
                missionQualityAssurance: v
            });
        } else {
            this.setState({
                qauserid: -1,
                missionQualityAssurance: null
            });
        }
    }

    handleAddStakeholderOnClick = async (e) => {

        //e.preventDefault();
        //e.persist();

        var k = this.state.stakeholderRowKey;
        k = k + 1;

        var stakeholderArray = this.state.stakeholders;
        await stakeholderArray.push({
            stakeholderRowKey: k,
            stakeholderName: this.state.stakeholderName,
            stakeholderSurname: this.state.stakeholderSurname,
            stakeholderCompany: this.state.stakeholderCompany,
            stakeholderEmail: this.state.stakeholderEmail
        });

        await this.setState({
            stakeholders: stakeholderArray,
            stakeholderRowKey: k
        });

        //console.log(this.state.stakeholders);
    };

    handleRemoveStakeholderOnClick = (val) => {
        //console.log("handleRemoveStakeholderOnClick " + val);
        //console.log(this.state.stakeholders);
        for (var i = 0; i < this.state.stakeholders.length; i++) {
            if (this.state.stakeholders[i].stakeholderRowKey == val) {
                this.state.stakeholders.splice(i, 1);
            }
        }

        this.forceUpdate();
    };

    getUserType = () => {
        let pageData = {
            operation: "GetUserType"
        };

        fetch(global.variables.API_USEROPERATIONS_GETUSERTYPE, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(pageData)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                this.setState({ userType: result.userType });
            });
    }

    createMission = async () => {

        await this.setState({ isFetching: true });

        console.log(this.state);

        //toast.success("Create Mission!", {
        //    position: toast.POSITION.BOTTOM_RIGHT
        //});

        await fetch(global.variables.API_CREATEMISSION, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(this.state)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if (result.resultstate === 0) {
                    toast.success("Create Mission Success!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                } else {
                    toast.error("Create Mission Failed!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                }
            });

        await this.setState({ isFetching: false });
    };

    handletypeOfROMSelectChange = async (e, v) => {
        e.persist();

        if (v !== undefined & v !== null) {
            await this.setState({ typeOfROM: v.TypeId });
        } else {
            await this.setState({ typeOfROM: -1 });
        }

        console.log(e.target.name + ": " + e.target.value);
        console.log(this.state);
    }

    loadPageProjects = async () => {
        let pageData = { operation: "GetListOfProjects" };

        await fetch(global.variables.API_PROJECTDETAILS_GETLISTOFALLPROJECTS, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(pageData)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                this.setState({ projects: result.projects });
            });
    }

    loadPageUsers = () => {
        let pageData = { operation: "LoadPageUsers" };

        fetch(global.variables.API_ASSIGNMISSION_LOADPAGE_USERS, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(pageData)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                this.setState({ users: result.listofusers });
            });
    }

    loadPage = async () => {
        await fetch(global.variables.API_CREATEMISSION_LOADPAGE, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(this.state)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if (result.resultstate === 0) {
                    this.setState({
                        notAuthorized: false,
                        loading: false
                    });
                } else if (result.resultstate === 2) {
                    this.setState({
                        notAuthorized: true,
                        loading: false
                    });
                } else {
                    this.setState({
                        notAuthorized: true,
                        loading: false
                    });
                }
            });
    }

    render() {
        const {
            projects,
            typeOfROM,
            //projectTitle,
            //projectNumber,
            //status,
            //sector,
            //smcsCode,
            //cfcuContractManager,
            //deuaSectorExpert,
            //deuaMonitoringExpert,
            //eudSectorManager,
            //beneficiaryInstitution,
            //contractingPartner,
            //totalBudget,
            //euContribution,
            //nationalCoFinancing,
            //otherCoFinancing,
            //totalFundsDisbursed,
            //lastDateOfPayment,
            //contractorSignatureDate,
            //projectStartDate,
            //finalDate,
            reasonfortheRomReview,
            //romExpertName,
            //coMonitor,
            fieldPhaseStartDate,
            fieldPhaseEndDate,
            missionMonitor,
            missionQualityController,
            missionQualityAssurance,
            stakeholderName,
            stakeholderSurname,
            stakeholderCompany,
            stakeholderEmail,
            stakeholders,
            missions,
            users,
            monuserid,
            qcuserid,
            qauserid,
            isFetching,
            userType,
        } = this.state;

        const columns = [
            {
                name: "stakeholderRowKey",
                options: {
                    display: true
                }
            },
            {
                name: "stakeholderName",
                label: "stakeholderName",
                //options: {
                //    filter: true,
                //    sort: true
                //}
            },
            {
                name: "stakeholderSurname",
                label: "stakeholderSurname",
                //options: {
                //    filter: true,
                //    sort: true
                //}
            },
            {
                name: "stakeholderCompany",
                label: "stakeholderCompany"
            },
            {
                name: "stakeholderEmail",
                label: "stakeholderEmail"
            },
            {
                name: "Actions",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRender: (value, tableMeta, updateValue) => {

                        return (
                            <div>
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    component="a"
                                //onClick={this.handleRemoveStakeholderOnClick(tableMeta.rowData[0])}
                                //target="_blank"
                                >
                                    Remove
                                </Button>
                            </div>
                        );
                    }
                }
            }
        ];

        const options = {
            //filterType: "checkbox"
        };


        if (this.state.loading) {
            return (
                <Grid container spacing={3} >
                    <Grid item xs={12} className="mt-2" style={{ textAlign: "center", display: this.state.loading ? "block" : "none" }}>
                        <CircularProgress /> Loading...
                    </Grid>
                </Grid>
            );
        } else if (this.state.notAuthorized) {
            return (
                <p>You are not authorized</p>
            );
        } else {

            return (
                <Grid container spacing={3} >
                    <Grid>
                        <ToastContainer />
                    </Grid>
                    <Grid item xs={12}>
                        <ProjectSelect
                            title="Please Select Project Title or Project Number"
                            projects={projects}
                            onchange={this.handleProjectSelectChange.bind(this)}
                            userType={userType}
                        />
                    </Grid>
                    {
                        //<Grid item xs={6} height="100%">
                        //    <ProjectData
                        //        onChange={this.handleChange}
                        //        onChangetypeOfROM={this.handletypeOfROMSelectChange}
                        //        typeOfROM={typeOfROM}
                        //        projectTitle={projectTitle}
                        //        projectNumber={projectNumber}
                        //        status={status}
                        //    />
                        //</Grid>
                        //<Grid item xs={6} height="100%">
                        //    <ProjectKeyInformation
                        //        onChange={this.handleChange}
                        //        sector={sector}
                        //        smcsCode={smcsCode}
                        //    />
                        //</Grid>
                        //<Grid item xs={6} height="100%">
                        //    <EntityInCharge
                        //        onChange={this.handleChange}
                        //        cfcuContractManager={cfcuContractManager}
                        //        deuaSectorExpert={deuaSectorExpert}
                        //        deuaMonitoringExpert={deuaMonitoringExpert}
                        //        eudSectorManager={eudSectorManager}
                        //        beneficiaryInstitution={beneficiaryInstitution}
                        //        contractingPartner={contractingPartner}
                        //    />
                        //</Grid>
                        //<Grid item xs={6} height="100%">
                        //    <ProjectFinancialData
                        //        onChange={this.handleChange}
                        //        onChangeDate={(name, value) =>
                        //            this.handleChangeDate(name, value)
                        //        }
                        //        totalBudget={totalBudget}
                        //        euContribution={euContribution}
                        //        nationalCoFinancing={nationalCoFinancing}
                        //        otherCoFinancing={otherCoFinancing}
                        //        totalFundsDisbursed={totalFundsDisbursed}
                        //        lastDateOfPayment={lastDateOfPayment}
                        //    />
                        //</Grid>
                        //<Grid item xs={6} height="100%">
                        //    <ProjectDates
                        //        onChange={(name, value) => this.handleChangeDate(name, value)}
                        //        contractorSignatureDate={contractorSignatureDate}
                        //        projectStartDate={projectStartDate}
                        //        finalDate={finalDate}
                        //    />
                        //</Grid>
                    }
                    <Grid item xs={6} height="100%">
                        <RomData
                            //onChangetypeOfROM={this.handletypeOfROMSelectChange}
                            onSelectChange={this.handleSelectChange}
                            typeOfROM={typeOfROM}
                            userType={userType}
                        />
                    </Grid>
                    <Grid item xs={6} height="100%">
                        <RomReview
                            onChangeDate={(name, value) =>
                                this.handleChangeDate(name, value)
                            }
                            onChange={this.handleChange}
                            reasonfortheRomReview={reasonfortheRomReview}
                            //romExpertName={romExpertName}
                            //coMonitor={coMonitor}
                            fieldPhaseStartDate={fieldPhaseStartDate}
                            fieldPhaseEndDate={fieldPhaseEndDate}
                            userType={userType}
                        />
                    </Grid>




                    <Grid item xs={12} className="mt-1">
                        <Card>
                            <CardHeader title="Add Project Monitor" className="romis-card-header"></CardHeader>
                            <CardContent>
                                <Grid container spacing={2}>

                                    <Grid item xs={12}>

                                        {
                                            //<TextField
                                            //    fullWidth
                                            //    placeholder="E-Mail"
                                            //    margin="normal"
                                            //    onChange={this.handleChange.bind(this)}
                                            //    value={projectMonitor}
                                            //    name="projectMonitor"
                                            ///>
                                        }

                                        <Autocomplete
                                            options={users}
                                            //getOptionLabel={option => option.LoginUsername + " " + option.LoginEmail + " " + option.LoginName + " " + option.LoginSurname}
                                            getOptionLabel={option => option.LoginName + " " + option.LoginSurname}
                                            autoComplete
                                            includeInputInList
                                            onChange={this.handleMONUserChange.bind(this)}
                                            renderInput={params => (
                                                <TextField {...params} label="Monitor" margin="normal" fullWidth />
                                            )}
                                            value={missionMonitor}
                                        />

                                    </Grid>
                                    {
                                        //<Grid item xs={2}>
                                        //    <Button variant="contained" color="primary" className="mt"
                                        //        onClick={this.handleMONUserRecord.bind(this)}>Confirm & Add</Button>
                                        //</Grid>
                                    }
                                </Grid>
                            </CardContent>
                        </Card>
                    </Grid>

                    <Grid item xs={12} className="mt-1">
                        <Card>
                            <CardHeader title="Add Project Quality Controller" className="romis-card-header"></CardHeader>
                            <CardContent>
                                <Grid container spacing={2}>

                                    <Grid item xs={12}>

                                        {
                                            //<TextField
                                            //    fullWidth
                                            //    placeholder="E-Mail"
                                            //    margin="normal"
                                            //    onChange={this.handleChange.bind(this)}
                                            //    value={projectQualityController}
                                            //    name="projectQualityController"

                                            ///>
                                        }

                                        <Autocomplete
                                            options={users}
                                            //getOptionLabel={option => option.LoginUsername + " " + option.LoginEmail + " " + option.LoginName + " " + option.LoginSurname}
                                            getOptionLabel={option => option.LoginName + " " + option.LoginSurname}
                                            autoComplete
                                            includeInputInList
                                            onChange={this.handleQCUserChange.bind(this)}
                                            renderInput={params => (
                                                <TextField {...params} label="Quality Controller" margin="normal" fullWidth />
                                            )}
                                            value={missionQualityController}
                                        />
                                    </Grid>
                                    {
                                        //<Grid item xs={2}>
                                        //    <Button variant="contained" color="primary" className="mt"
                                        //        onClick={this.handleQCUserRecord.bind(this)}>Confirm & Add</Button>
                                        //</Grid>
                                    }
                                </Grid>


                            </CardContent>
                        </Card>
                    </Grid>

                    <Grid item xs={12} className="mt-1">
                        <Card>
                            <CardHeader title="Add Project Quality Assurance" className="romis-card-header"></CardHeader>
                            <CardContent>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <Autocomplete
                                            options={users}
                                            //getOptionLabel={option => option.LoginUsername + " " + option.LoginEmail + " " + option.LoginName + " " + option.LoginSurname}
                                            getOptionLabel={option => option.LoginName + " " + option.LoginSurname}
                                            autoComplete
                                            includeInputInList
                                            onChange={this.handleQAUserChange.bind(this)}
                                            renderInput={params => (
                                                <TextField {...params} label="Quality Assurance" margin="normal" fullWidth />
                                            )}
                                            value={missionQualityAssurance}
                                        />
                                    </Grid>
                                    {
                                        //<Grid item xs={2}>
                                        //    <Button variant="contained" color="primary" className="mt"
                                        //        onClick={this.handleQAUserRecord.bind(this)}>Confirm & Add</Button>
                                        //</Grid>
                                    }
                                </Grid>
                            </CardContent>
                        </Card>
                    </Grid>


                    <Grid item xs={12} className="mt-1">
                        <Card>
                            <CardHeader title="Add Stakeholder" className="romis-card-header"></CardHeader>
                            <CardContent>
                                <Grid container spacing={2}>
                                    <Grid item xs={3}>
                                        <TextField
                                            placeholder="Name"
                                            fullWidth
                                            margin="normal"
                                            onChange={this.handleChange.bind(this)}
                                            value={stakeholderName}
                                            name="stakeholderName"
                                        />
                                    </Grid>
                                    <Grid item xs={3}>
                                        <TextField
                                            placeholder="Surname"
                                            fullWidth
                                            margin="normal"
                                            onChange={this.handleChange.bind(this)}
                                            value={stakeholderSurname}
                                            name="stakeholderSurname"
                                        />
                                    </Grid>
                                    <Grid item xs={3}>
                                        <TextField
                                            fullWidth
                                            placeholder="Company&Instutition"
                                            margin="normal"
                                            onChange={this.handleChange.bind(this)}
                                            value={stakeholderCompany}
                                            name="stakeholderCompany"
                                        />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <TextField
                                            fullWidth
                                            placeholder="E-Mail"
                                            margin="normal"
                                            onChange={this.handleChange.bind(this)}
                                            value={stakeholderEmail}
                                            name="stakeholderEmail"
                                        />
                                    </Grid>
                                    <Grid item xs={1}>
                                        <Button variant="contained" color="primary" className="mt"
                                            onClick={this.handleAddStakeholderOnClick.bind(this)}
                                            disabled={isFetching ? true : false}>Add</Button>
                                    </Grid>
                                </Grid>

                                <Table aria-label="simple table" className="mt-1">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Name </TableCell>
                                            <TableCell align="right">Surname </TableCell>
                                            <TableCell align="right">Company&Instutition</TableCell>
                                            <TableCell align="right">E-Mail</TableCell>
                                            <TableCell align="right">Options</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {stakeholders.map(({ stakeholderRowKey, stakeholderName, stakeholderSurname, stakeholderCompany, stakeholderEmail }, index) => {
                                            return (
                                                <TableRow key={stakeholderRowKey}>
                                                    <TableCell component="th" scope="row">{stakeholderName} </TableCell>
                                                    <TableCell align="right">{stakeholderSurname}</TableCell>
                                                    <TableCell align="right">{stakeholderCompany}</TableCell>
                                                    <TableCell align="right">{stakeholderEmail}</TableCell>
                                                    <TableCell align="right">
                                                        <Button variant="outlined" color="secondary"
                                                            onClick={this.handleRemoveStakeholderOnClick.bind(this, stakeholderRowKey)}
                                                            //onClick={() => { this.handleRemoveStakeholderOnClick(stakeholderRowKey) }}
                                                            disabled={isFetching ? true : false}
                                                        >
                                                            Remove
                                                        </Button>
                                                    </TableCell>
                                                </TableRow>
                                            )
                                        })}
                                    </TableBody>
                                </Table>

                                {
                                    //<MUIDataTable
                                    //    title={"Stakeholders"}
                                    //    data={stakeholders}
                                    //    columns={columns}
                                    //    options={options}
                                    ///>
                                }
                            </CardContent>
                        </Card>
                    </Grid>


                    <Grid item xs={12} style={{ textAlign: "center" }}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={this.createMission}
                            disabled={isFetching ? true : false}
                        >
                            Create Mission
                    </Button>
                        {
                            //<Button
                            //    variant="contained"
                            //    color="primary"
                            //    onClick={() => {
                            //        console.log(stores.userStore.fullName);
                            //        stores.userStore.setFirstName("ayse");
                            //    }}
                            //>
                            //    Mobx Action
                            //</Button>
                        }
                    </Grid>
                    <Grid>
                        <ToastContainer />
                    </Grid>
                </Grid >
            );
        }
    }
}
)
);

export { CreateMissionPage };




// WEBPACK FOOTER //
// ./src/pages/CreateMissionPage.js